import React, { memo } from 'react';
import { Navigate } from 'react-router-dom';

const isAuthenticated = () => sessionStorage.getItem('idToken') !== null;

const PrivateRoute = ({ element: Component }) => (isAuthenticated() ? Component : <Navigate to="/login" />);

export default memo(PrivateRoute);
